import { useCallback, useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { typeformScriptLoadedState } from "../states/TypeformStates";

const TypeformLoader = () => {
  const [loadedResources, setLoadedResources] = useState(0);
  const setTypeformLoaded = useSetRecoilState(typeformScriptLoadedState);

  const initTypeform = useCallback(() => {
    const script = document.createElement("script");
    script.src = "//embed.typeform.com/next/embed.js";
    script.id = "typeform-embed-js";
    script.onload = () => {
      setLoadedResources((r) => r + 1);
    };

    const style = document.createElement("link");
    style.rel = "stylesheet";
    style.href = "//embed.typeform.com/next/css/popup.css";
    style.onload = () => {
      setLoadedResources((r) => r + 1);
    };

    document.head.appendChild(script);
    document.head.appendChild(style);
  }, []);

  useEffect(() => {
    initTypeform();
  }, [initTypeform]);

  useEffect(() => {
    if (loadedResources === 2) {
      setTypeformLoaded(true);
    }
  }, [loadedResources]);

  return null;
};

export default TypeformLoader;
